import React, { useContext } from 'react';
import { Button, Popconfirm, Space, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';

import HolidaysContext from '@totem/components/holidays/HolidaysContext';
import { Holiday } from '@totem/components/holidays/types';
import IBDIcon from '@totem/styles/Icon';

const DATE_FORMAT = 'MMM D, YYYY';
const DATE_TIME_FORMAT = 'MMM D, YYYY h:mm A';

const HolidaysTable = () => {
  const { holidays, loading, saving, openEditModal, deleteHoliday } =
    useContext(HolidaysContext);

  const columns: ColumnsType<Holiday> = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: (value: string) =>
        value ? dayjs(value).format(DATE_FORMAT) : '—',
    },
    {
      title: 'Created By',
      dataIndex: 'createdByName',
      key: 'createdByName',
      render: (value?: string) => value || '—',
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (value: string) =>
        value ? dayjs(value).format(DATE_TIME_FORMAT) : '—',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space>
          <Button
            title={'Edit'}
            shape={'circle'}
            onClick={() => openEditModal(record)}
            icon={<IBDIcon name={'Edit'} />}
          />
          <Popconfirm
            title="Delete this holiday?"
            okText="Yes"
            cancelText="No"
            placement="left"
            onConfirm={() => deleteHoliday(record.id)}
          >
            <Button
              title={'Delete'}
              shape={'circle'}
              danger
              icon={<IBDIcon name={'Delete'} />}
            />
          </Popconfirm>
        </Space>
      ),
      width: 200,
    },
  ];

  return (
    <Table<Holiday>
      rowKey="id"
      dataSource={holidays}
      columns={columns}
      loading={loading || saving}
      pagination={false}
    />
  );
};

export default HolidaysTable;
